import { Component } from '@angular/core';
// import { SessionService } from './session.service';
import { Router } from '@angular/router';



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  verifyToken;
  private canRequest: Boolean = true

  constructor(private router: Router) { }


  // constructor(private router: Router, private session: SessionService){
  //
  //   if (localStorage.getItem("clusterID") != null) {
  //     session.sessionVerifyToken()
  //     .subscribe(
  //       (data:any) => {
  //         let json = data;
  //         if (json.status === "0") {
  //           router.navigate(['/login']);
  //           session.logOut();
  //         }
  //       },
  //       (err: Response) => {
  //         if(err.status === 401){
  //           router.navigate(['/login']);
  //           session.logOut();
  //         }
  //       });
  //   }
  //
  //   this.verifyUserToken();
  //
  // }

  // verifyUserToken(){
  //   this.verifyToken = setInterval(() => {
  //     if (localStorage.getItem("clusterID") != null && this.canRequest) {
  //       this.changeCanRequest();
  //       this.session.sessionVerifyToken()
  //         .subscribe(
  //           (data:any) => {
  //             this.changeCanRequest();
  //             let json = data;
  //             if (json.status === "0") {
  //               this.router.navigate(['/login']);
  //               this.session.logOut();
  //             }
  //           },
  //           (err: any) => {
  //             if(err.status == 569){
  //               this.changeCanRequest();
  //
  //             }else{
  //               this.router.navigate(['/login']);
  //               this.session.logOut();
  //             }
  //           });
  //     }
  //   }, 10000)
  // }

  changeCanRequest(){
    this.canRequest = !this.canRequest;
  }




}
